import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inline-flex items-center space-x-2 text-gray-400"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Fetching Minted NFTs...", -1)
const _hoisted_3 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mb-8" }

import {
  computed, ref, toRefs, watchEffect,
} from 'vue';
import { PublicKey } from '@solana/web3.js';
import { AccountPresenter, CandyMachineAccount, CandyMachineV2Account } from '@/models';
import { useWorkspace } from '@/composables';
import { accountPublicKeys, getAccountRoute, metaplexConstants } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null
  },
  setup(__props: any) {

const props = __props as {
  account: CandyMachineAccount | CandyMachineV2Account,
  presenter: AccountPresenter,
}



const { account } = toRefs(props);
const { connection } = useWorkspace();

const getFirstCreator = async () => {
  if (account.value instanceof CandyMachineAccount) return account.value.publicKey;
  return account.value.findCreatorAddress();
};

const getMetadataPublicKeys = async () => {
  const firstCreator = await getFirstCreator();
  const metadataAccounts = await connection.value.getProgramAccounts(
    accountPublicKeys.tokenMetadataProgram,
    {
      dataSlice: { offset: 0, length: 0 },
      filters: [
        { dataSize: metaplexConstants.MAX_METADATA_LEN },
        {
          memcmp: {
            offset: metaplexConstants.CREATOR_ARRAY_START,
            bytes: firstCreator.toBase58(),
          },
        },
      ],
    },
  );

  return metadataAccounts.map(({ pubkey }) => pubkey);
};

const perPage = 6;
const page = ref(1);
const loading = ref(false);
const nfts = ref<PublicKey[]>([]);
const paginatedNfts = computed(() => nfts.value.slice(
  (page.value - 1) * perPage,
  page.value * perPage,
));

watchEffect(async () => {
  try {
    loading.value = true;
    nfts.value = await getMetadataPublicKeys();
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_icon_loading = _resolveComponent("icon-loading")!
  const _component_nft_card = _resolveComponent("nft-card")!
  const _component_fetch_multiple_accounts = _resolveComponent("fetch-multiple-accounts")!
  const _component_base_pagination = _resolveComponent("base-pagination")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_icon_loading, { class: "w-5 h-5 text-gray-300 animate-spin" }),
        _hoisted_2
      ]))
    : (nfts.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " No NFTs were minted from that Candy Machine yet. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createVNode(_component_fetch_multiple_accounts, { addresses: _unref(paginatedNfts) }, {
              default: _withCtx(({ accounts }) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts, ({ account, loading }, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: account?.publicKey?.toBase58() ?? index
                  }, [
                    _createVNode(_component_nft_card, {
                      metadata: account?.metadata ?? {},
                      loading: loading,
                      error: !account?.metadata,
                      to: account?.decodedData?.mint ? _unref(getAccountRoute)(account.decodedData.mint) : null
                    }, null, 8, ["metadata", "loading", "error", "to"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["addresses"])
          ]),
          _createVNode(_component_base_pagination, {
            class: "mt-8",
            page: page.value,
            "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((page).value = $event)),
            perPage: perPage,
            total: nfts.value.length
          }, null, 8, ["page", "total"])
        ]))
}
}

})